// extracted by css-extract-rspack-plugin
export default {"root":"root-ncLXq9","card":"card-MQ9vMn","decorate":"decorate-rmKNoM","title":"title-C8m7Ry","buttons":"buttons-riZeHe","button":"button-uYPUIk"};